import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { closeYodleeOnboarding, resetYodleeOnboarding, selectProvider, attemptProviderMFA } from "../../actions/yodlee";
import { RESET_PLAID_ONBOARDING } from "../../actions/financial-data";
var initialState = {};
export default (function (CHANGE_TYPE) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case CHANGE_TYPE:
        {
          var _action$payload = action.payload,
              key = _action$payload.key,
              value = _action$payload.value;
          return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, value));
        }
      // Form state is cleared when:
      // - onboarding is explicitly reset
      // - when a new provider is selected
      // - we successfully attempt MFA
      // The last case is necessary for providers that have a two-part MFA process
      // For example, the first step might be entering their phone number and the
      // second step might be entering the security code sent to that phone number.
      // For the second step, some providers send an input that has the exact same
      // key as the first step, resulting in users seeing the new input already
      // populated with data they had entered in the first step. By resetting the form
      // data after a successful request to send MFA data, we fix this issue.

      case attemptProviderMFA.SUCCESS_TYPE:
      case closeYodleeOnboarding.getType():
      case resetYodleeOnboarding.getType():
      case RESET_PLAID_ONBOARDING:
      case selectProvider.getType():
        return initialState;

      default:
        return state;
    }
  };
});